import GameBanner from "../banner"
import Gcash from "../gcash"

export const Pay = () => {
    return (
        <>
            <GameBanner />
            <Gcash />
        </>
    )
}
